import { Injectable } from '@angular/core';
import { BaseService as __BaseService } from '../base-service';
import { Observable as __Observable, BehaviorSubject, combineLatest, of, timer } from 'rxjs';
import { map as __map, filter as __filter, map, take, mergeMap, startWith } from 'rxjs/operators';
import { AngularFirestore, Query } from '@angular/fire/firestore';
import { Order, OrderStatus, initializeProofOfDelivery, CustomerStatus, OrderSubStatus } from '../models/order';
import { Member } from '../models/member';
import { Merchant } from '../models/merchant';
import { Location } from '../models/location';
import { MemberService } from './member.service';
import { LocationService } from './location.service';
import { EmployeeService } from './employee.service';
import { MerchantService } from './merchant.service';
import { Employee } from '../models/employee';
import * as firebase from 'firebase';
import { Chat } from '../models/chat';
import { RecentChatService } from './recent-chats.service';
import { AngularFireAuth } from '@angular/fire/auth';
import { GeoFirestore, GeoCollectionReference } from 'geofirestore';
import { OrderLocationService } from './order-location.service';
import { ToastController } from '@ionic/angular';
import { GeolocationService } from './geolocation.service';
import { LoadingController } from '@ionic/angular';
import { OrderLocation } from '../models/order_location';
import { sortBy, sortByAll, orderBy } from 'lodash';
import { DatePipe } from '@angular/common';
import { LineItems } from '../models/transaction';
@Injectable({
  providedIn: 'root'
})
export class OrderService {

  private collectionName = 'orders';
  private subscription = new Map();
  private everyMinute$: __Observable<number> = timer(0, 60000);
  ordersIn2miles = {}
  locationTimers = {}
  geoFirestore: GeoCollectionReference;

  mileSubject = new BehaviorSubject({});
  orderChat$: __Observable<any>;

  setMiles() {
    this.mileSubject.next(this.ordersIn2miles);
  }
  constructor(private firestore: AngularFirestore, private memberService: MemberService,
    private locationService: LocationService,
    private employeeService: EmployeeService,
    private merchantService: MerchantService,
    private recentchatsService: RecentChatService,
    private orderLocationService: OrderLocationService,
    private toastController: ToastController,
    private geolocationService: GeolocationService,
    private loadingController: LoadingController,
    private af: AngularFireAuth,
    private datePipe: DatePipe) {
    const geofirestore = new GeoFirestore(firebase.firestore());
    this.geoFirestore = geofirestore.collection('order_location');
  }


  sortByCustomerStatus(a, b) {
    if (a.customer_status === CustomerStatus.CHECKED_IN && b.customer_status !== CustomerStatus.CHECKED_IN) return -1;
    if (a.customer_status === CustomerStatus.NA && b.customer_status !== CustomerStatus.NA) return 1;
    if (a.customer_status === CustomerStatus.ON_MY_WAY && b.customer_status === CustomerStatus.CHECKED_IN) return 1;
    if (a.customer_status === CustomerStatus.ON_MY_WAY && b.customer_status === CustomerStatus.NA) return -1;
    return 0;
  }

  sortArrivalBasedOnStatus(a, b) {
    if (a.customer_status === CustomerStatus.CHECKED_IN && b.customer_status === CustomerStatus.CHECKED_IN) {
      if (a.customer_status_updated_at > b.customer_status_updated_at) return 1
      else return -1
    }

    if (a.customer_status === CustomerStatus.NA && b.customer_status === CustomerStatus.NA) {
      if (a.pickup_at > b.pickup_at) return 1
      else return -1
    }
    return 0

  }
  getOrdersByFilter(merchantID: string, fields: any): __Observable<Order[]> {
    const searchRef = this.firestore.collection<Order>(this.collectionName,
      ref => {
        let query: Query = ref.where('merchant_id', '==', merchantID)
          .where('location_id', '==', this.employeeService.employee.location_ids[0]);
        for (let [key, value] of fields) {

          if (key === 'include_completed' && !fields.get('include_completed')) {
            console.log(fields.get(key))
            query = query.where('status', 'in', [OrderStatus.READY, OrderStatus.ACTIVE])
          }

        }

        return query;
      })
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as Order;
          const id = a.payload.doc.id;
          return { id, ...data };
        })
          .filter(
            (order: Order) => {
              let filterFlag = true
              for (let [key, value] of fields) {

                if (key === 'include_assigned' && !fields.get('include_assigned') && filterFlag) {
                  filterFlag = order.assigned_employee ? true : false
                }

                if (key === 'order_status' && filterFlag) {
                  filterFlag = order.sub_status == value ? true : false
                }

                // if (key === 'memberIds' && filterFlag) {
                //   filterFlag = value.includes(order.customer_id) ? true : false
                // }

                if (key === 'email' && filterFlag) {
                  filterFlag = order.customer.email == value ? true : false
                }

                if (key === 'phone_number' && filterFlag) {
                  filterFlag = order.customer.phone_number == value ? true : false
                }

                if (key === 'plate_number' && filterFlag) {
                  filterFlag = order.member_vehicle && order.member_vehicle.plate_number == value.toLocaleLowerCase() ? true : false
                }

                if (key === 'external_order_id' && filterFlag) {
                  filterFlag = order.external_order_id == value ? true : false
                }

                if (key === 'customer_status' && filterFlag) {
                  filterFlag = order.customer_status == value ? true : false
                }

              }

              if (filterFlag) {
                return order
              }
            }
          )
      })
      );
    return searchRef;
  }

  getQueueOrders(merchantID: string, fields: any, emp?: Employee): __Observable<Order[]> {
    //temp collections
    var assignee_ids: string[] = []
    var member_ids = []
    var order_ids = []
    if (!emp) {
      emp = this.employeeService.employee as Employee;
    }
    if (emp.is_owner) {
      // debugger
      const order$ = this.firestore.collection<Order>(this.collectionName,
        ref => {
          let query: Query = ref.where('merchant_id', '==', merchantID)
            .where('location_id', '==', this.employeeService.defaultLocation)
            .orderBy("pickup_at", "asc")
          for (let [key, value] of fields) {

            if (key === 'include_completed' && !fields.get('include_completed')) {
              console.log(fields.get(key))
              query = query.where('status', 'in', [OrderStatus.READY, OrderStatus.ACTIVE])
            }

          }

          return query;
        })
        // ref => ref

        // .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY]) //not complete orders
        // .where('merchant_id', '==', merchantID) //TODO: Fetch merchant id based on logged in worker
        // // .where('assigned_employee', '==', null)
        // .where('location_id', '==', this.employeeService.employee.location_ids[0])
        // .orderBy("pickup_at", "asc"))
        .valueChanges({ idField: 'id' })
        .pipe(
          map(orders => {
            return orders.map((order: Order) => {
              assignee_ids.push(order.assigned_employee);
              member_ids.push(order.customer_id);
              order_ids.push(order.id);
              // if ((order.assigned_employee != null) && (typeof (order.assigned_employee) === 'string')) {
              //   this.employeeService.employeeById(order.assigned_employee).subscribe(res => {
              //     if (res) {
              //       order.employee = res
              //     }
              //   })
              // }
              order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)
             
              return order;
            })
          })
        );

      const emp$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.employeeService.employeeById(order.assigned_employee);
            } catch (error) {
              return of({} as Employee);
            }
          })
        );
      }));

      const mem$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.memberService.memberById(order.customer_id);
            } catch (error) {
              return of({} as Member);
            }
          })
        );
      }));


      const eta$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.orderLocationService.orderById(order.id);
            } catch (error) {
              return of({} as OrderLocation);
            }
          })
        );
      }));
      const combinedData = combineLatest(
        order$,
        mem$.pipe(startWith(null)),
        emp$.pipe(startWith(null)),
        eta$.pipe(startWith(null)));

      const result$ = combinedData.pipe(
        map(([orders, members, employees, etas]) => {
          //lookup and update order
          return orders.map(order => {
            if (order.customer_status === CustomerStatus.CHECKED_IN && order.status !== OrderStatus.COMPLETED) {
              if (this.subscription.has(order.id)) {
                this.subscription.get(order.id).unsubscribe()
              }
              this.subscription.set(order.id,
                this.everyMinute$.subscribe(() => {
                  order.waiting_time = this.getTimeDifferenceString(order.customer_status_updated_at, true);
                }))
              // this.getTimeDifferenceString(order.customer_status_updated_at, true).subscribe((time)=>{
              //     order.waiting_time = time
              // })
            } else {
              for (let [orderId, subs] of this.subscription) {
                if (this.subscription.has(order.id)) {
                  if (order.customer_status !== CustomerStatus.CHECKED_IN && order.id === orderId) {
                    subs.unsubscribe()
                  }
                }
              }
            }
            var res: any;
            try {
              order.assigned_employee_object = employees ? employees.find(employee => employee && employee.id && employee.id === order.assigned_employee) : null;

              order.customer = members ? members.find(member => member && member.id && member.id === order.customer_id) : null;

              order.eta_object = etas ? etas.find(eta => eta && eta.order_id && eta.order_id === order.id) : null;

              res = this.getSortedOrder(order);
              return res;
            } catch (error) {
              console.log(error)
            }
          })
            .sort((a, b) => this.sortByCustomerStatus(a, b))
            .sort((c, d) => this.sortArrivalBasedOnStatus(c, d))
            .filter(
              (order: Order) => {
                let filterFlag = true

                filterFlag = this.employeeService.employee.location_ids.includes(order.location_id) ? true : false

                for (let [key, value] of fields) {

                  if (key === 'include_assigned' && !fields.get('include_assigned') && filterFlag) {
                    filterFlag = order.assigned_employee ? false : true
                  }

                  if (key === 'order_status' && filterFlag) {
                    filterFlag = order.sub_status == value ? true : false
                  }

                  // if (key === 'memberIds' && filterFlag) {
                  //   filterFlag = value.includes(order.customer_id) ? true : false
                  // }

                  if (key === 'email' && filterFlag) {
                    filterFlag = order.customer && order.customer.email == value ? true : false
                  }

                  if (key === 'phone_number' && filterFlag) {
                    filterFlag = order.customer && order.customer.phone_number == value ? true : false
                  }

                  if (key === 'plate_number' && filterFlag) {
                    filterFlag = order.member_vehicle && order.member_vehicle.plate_number == value.toLocaleLowerCase() ? true : false
                  }

                  if (key === 'external_order_id' && filterFlag) {
                    filterFlag = order.external_order_id == value ? true : false
                  }

                  if (key === 'customer_status' && filterFlag) {
                    filterFlag = order.customer_status == value ? true : false
                  }

                  if (key === 'created_at' && filterFlag) {
                    let startDate = new Date(value)
                    let endDate = new Date(value)
                    if (fields.get('created_at_days') > 0) {
                      startDate.setDate(startDate.getDate() - fields.get('created_at_days'));
                      endDate.setDate(endDate.getDate() + fields.get('created_at_days'));
                    }
                    else {
                      startDate.setHours(0, 0, 0, 0);
                      endDate.setHours(23, 59, 59, 999);
                    }

                    if (startDate.getTime() / 1000 < order.created_at.seconds && order.created_at.seconds < endDate.getTime() / 1000) {
                      filterFlag = true
                    }
                    else {
                      filterFlag = false
                    }
                  }

                  if (key === 'pickup_at' && filterFlag) {
                    let startDate = new Date(value)
                    let endDate = new Date(value)
                    if (fields.get('pickup_at_days') > 0) {
                      startDate.setDate(startDate.getDate() - fields.get('pickup_at_days'));
                      endDate.setDate(endDate.getDate() + fields.get('pickup_at_days'));
                    }
                    else {
                      startDate.setHours(0, 0, 0, 0);
                      endDate.setHours(23, 59, 59, 999);
                    }

                    if (startDate.getTime() / 1000 < order.pickup_at.seconds && order.pickup_at.seconds < endDate.getTime() / 1000) {
                      filterFlag = true
                    }
                    else {
                      filterFlag = false
                    }
                  }

                }

                if (filterFlag) {
                  return order
                }
              }
            )
        })
      ).pipe(
        map(data => orderBy(data, 'custom_sort'))
      );
      return result$;
    }
    else {
      const order$ = this.firestore.collection<Order>(this.collectionName,
        ref => {
          let query: Query = ref.where('merchant_id', '==', merchantID)
          .where('location_id', '==', this.employeeService.defaultLocation)
            .orderBy("pickup_at", "asc")
          for (let [key, value] of fields) {

            if (key === 'include_completed' && !fields.get('include_completed')) {
              console.log(fields.get(key))
              query = query.where('status', 'in', [OrderStatus.READY, OrderStatus.ACTIVE])
            }

          }

          return query;
        })
        //  ref => ref
        // .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY]) //not complete orders
        // .where('merchant_id', '==', merchantID) //TODO: Fetch merchant id based on logged in worker
        // // .where('assigned_employee', '==', null)
        // .where('location_id', '==', this.employeeService.employee.location_ids[0])
        // .orderBy("pickup_at", "asc"))
        .valueChanges({ idField: 'id' })
        .pipe(
          map(orders => {
            return orders.map((order: Order) => {
              // debugger;
              assignee_ids.push(order.assigned_employee);
              member_ids.push(order.customer_id);
              order_ids.push(order.id);
              // if ((order.assigned_employee != null) && (typeof (order.assigned_employee) === 'string')) {
              //   this.employeeService.employeeById(order.assigned_employee).subscribe(res => {
              //     if (res) {
              //       order.employee = res
              //     }
              //   })
              // }
              order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)

              return order;
            })
          })
        );

      const emp$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.employeeService.employeeById(order.assigned_employee);
            } catch (error) {
              return of({} as Employee);
            }
          })
        );
      }));

      const mem$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.memberService.memberById(order.customer_id);
            } catch (error) {
              return of({} as Member);
            }
          })
        );
      }));

      const eta$ = order$.pipe(mergeMap(orders => {
        return combineLatest(
          orders.map(order => {
            try {
              return this.orderLocationService.orderById(order.id);
            } catch (error) {
              return of({} as OrderLocation);
            }
          })
        );
      }));
      const combinedData = combineLatest(
        order$,
        mem$.pipe(startWith(null)),
        emp$.pipe(startWith(null)),
        eta$.pipe(startWith(null)));

      const result$ = combinedData.pipe(
        map(([orders, members, employees, etas]) => {
          //lookup and update order
          return orders.map(order => {
            if (order.customer_status === CustomerStatus.CHECKED_IN && order.status !== OrderStatus.COMPLETED) {
              if (this.subscription.has(order.id)) {
                this.subscription.get(order.id).unsubscribe()
              }
              this.subscription.set(order.id,
                this.everyMinute$.subscribe(() => {
                  order.waiting_time = this.getTimeDifferenceString(order.customer_status_updated_at, true);
                }))
              // this.getTimeDifferenceString(order.customer_status_updated_at, true).subscribe((time)=>{
              //     order.waiting_time = time
              // })
            } else {
              for (let [orderId, subs] of this.subscription) {
                if (this.subscription.has(order.id)) {
                  if (order.customer_status !== CustomerStatus.CHECKED_IN && order.id === orderId) {
                    subs.unsubscribe()
                  }
                }
              }
            }
            var res: any;
            try {
              // debugger
              order.assigned_employee_object = employees ? employees.find(employee => employee && employee.id && employee.id === order.assigned_employee) : null;

              order.customer = members ? members.find(member => member && member.id && member.id === order.customer_id) : null;

              order.eta_object = etas ? etas.find(eta => eta && eta.order_id && eta.order_id === order.id) : null;

              res = this.getSortedOrder(order);
              return res;
            } catch (error) {
              console.log(error)
            }
          })
            // .sort((a, b) => this.sortByCustomerStatus(a, b))
            .sort((c, d) => this.sortArrivalBasedOnStatus(c, d))
            .filter(
              (order: Order) => {
                let filterFlag = true

                filterFlag = this.employeeService.employee.location_ids.includes(order.location_id) ? true : false

                for (let [key, value] of fields) {

                  if (key === 'include_assigned' && !fields.get('include_assigned') && filterFlag) {
                    filterFlag = order.assigned_employee ? false : true
                  }

                  if (key === 'order_status' && filterFlag) {
                    filterFlag = order.sub_status == value ? true : false
                  }

                  // if (key === 'memberIds' && filterFlag) {
                  //   filterFlag = value.includes(order.customer_id) ? true : false
                  // }

                  if (key === 'email' && filterFlag) {
                    filterFlag = order.customer && order.customer.email == value ? true : false
                  }

                  if (key === 'phone_number' && filterFlag) {
                    filterFlag = order.customer && order.customer.phone_number == value ? true : false
                  }

                  if (key === 'plate_number' && filterFlag) {
                    filterFlag = order.member_vehicle && order.member_vehicle.plate_number == value.toLocaleLowerCase() ? true : false
                  }

                  if (key === 'external_order_id' && filterFlag) {
                    filterFlag = order.external_order_id == value ? true : false
                  }

                  if (key === 'customer_status' && filterFlag) {
                    filterFlag = order.customer_status == value ? true : false
                  }

                  if (key === 'created_at' && filterFlag) {
                    let startDate = new Date(value)
                    let endDate = new Date(value)
                    if (fields.get('created_at_days') > 0) {
                      startDate.setDate(startDate.getDate() - fields.get('created_at_days'));
                      endDate.setDate(endDate.getDate() + fields.get('created_at_days'));
                    }
                    else {
                      startDate.setHours(0, 0, 0, 0);
                      endDate.setHours(23, 59, 59, 999);
                    }

                    if (startDate.getTime() / 1000 < order.created_at.seconds && order.created_at.seconds < endDate.getTime() / 1000) {
                      filterFlag = true
                    }
                    else {
                      filterFlag = false
                    }
                  }

                  if (key === 'pickup_at' && filterFlag) {
                    let startDate = new Date(value)
                    let endDate = new Date(value)
                    if (fields.get('pickup_at_days') > 0) {
                      startDate.setDate(startDate.getDate() - fields.get('pickup_at_days'));
                      endDate.setDate(endDate.getDate() + fields.get('pickup_at_days'));
                    }
                    else {
                      startDate.setHours(0, 0, 0, 0);
                      endDate.setHours(23, 59, 59, 999);
                    }

                    if (startDate.getTime() / 1000 < order.pickup_at.seconds && order.pickup_at.seconds < endDate.getTime() / 1000) {
                      filterFlag = true
                    }
                    else {
                      filterFlag = false
                    }
                  }

                }

                if (filterFlag) {
                  return order
                }
              }
            )
          // .filter(order => {
          //   if (emp.location_ids.includes(order.location_id)) {
          //     return order;
          //   }
          // })
        })
      ).pipe(
        map(data => orderBy(data, 'custom_sort'))
      );
      return result$;
    }

  }

  getOpenOrdersForWorker(): __Observable<Order[]> {
    //temp collections
    var assignee_ids: string[] = []
    var member_ids = []
    var order_ids = []

    const order$ = this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY]) //not complete orders
      .where('merchant_id', '==', this.merchantService.merchant.id) 
      .where('assigned_employee', '==', this.af.auth.currentUser.uid)
      .where('location_id', '==', this.employeeService.defaultLocation)
      .orderBy("pickup_at", "asc"))
      .valueChanges({ idField: 'id' })
      .pipe(
        map(orders => {
          return orders.map((order: Order) => {
            assignee_ids.push(order.assigned_employee);
            member_ids.push(order.customer_id);
            order_ids.push(order.id);
            order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)
            return order;
          })
        })
      );

    // const emp$ = order$.pipe(mergeMap(orders => {
    //   return combineLatest(
    //     orders.map(order => {
    //       try {
    //         return this.employeeService.employeeById(order.assigned_employee);
    //       } catch (error) {
    //         return of({} as Employee);
    //       }
    //     })
    //   );
    // }));

    const mem$ = order$.pipe(mergeMap(orders => {
      return combineLatest(
        orders.map(order => {
          try {
            return this.memberService.memberById(order.customer_id);
          } catch (error) {
            return of({} as Member);
          }
        })
      );
    }));

    const eta$ = order$.pipe(mergeMap(orders => {
      return combineLatest(
        orders.map(order => {
          try {
            return this.orderLocationService.orderById(order.id);
          } catch (error) {
            return of({} as OrderLocation);
          }
        })
      );
    }));
    const combinedData = combineLatest(
      order$,
      mem$.pipe(startWith(null)),
      // emp$.pipe(startWith(null)),
      eta$.pipe(startWith(null)));

    const result$ = combinedData.pipe(
      map(([orders, members, etas]) => {
        //lookup and update order
        return orders.map(order => {
          if (order.customer_status === CustomerStatus.CHECKED_IN && order.status !== OrderStatus.COMPLETED) {
            if (this.subscription.has(order.id)) {
              this.subscription.get(order.id).unsubscribe()
            }
            this.subscription.set(order.id,
              this.everyMinute$.subscribe(() => {
                order.waiting_time = this.getTimeDifferenceString(order.customer_status_updated_at, true);
              }))
            // this.getTimeDifferenceString(order.customer_status_updated_at, true).subscribe((time)=>{
            //     order.waiting_time = time
            // })
          } else {
            for (let [orderId, subs] of this.subscription) {
              if (this.subscription.has(order.id)) {
                if (order.customer_status !== CustomerStatus.CHECKED_IN && order.id === orderId) {
                  subs.unsubscribe()
                }
              }
            }
          }
          var res: any;
          try {
            // order.assigned_employee_object = employees ? employees.find(employee => employee && employee.id && employee.id === order.assigned_employee) : null;

            order.customer = members ? members.find(member => member && member.id && member.id === order.customer_id) : null;

            order.eta_object = etas ? etas.find(eta => eta && eta.order_id && eta.order_id === order.id) : null;

            res = this.getQueueSortOrder(order);
            return res;
          } catch (error) {
            console.log(error)
          }
        })
        // .filter((order:Order) => {
        //   if (!customerStatusFilter.length) return true
        //   if (customerStatusFilter.includes(order.customer_status)) return true
        // })
          // .sort((a, b) => this.sortByCustomerStatus(a, b))
          // .sort((c, d) => this.sortArrivalBasedOnStatus(c, d))
      })
    // ).pipe(
    //   map(data => orderBy(data, 'custom_sort'))
    );
    return result$;
  }


  getQueueSortOrder(order: any){
    if (order.customer_status === CustomerStatus.CHECKED_IN){
      const sortCounter = 11111111111;
      order.custom_sort = sortCounter + order.customer_status_updated_at['seconds']
    }
    else if (order.customer_status == CustomerStatus.ON_MY_WAY){
      const sortCounter = 22222222222;
      if (order.eta_object && typeof order.eta_object.eta_value === 'number') {
        order.eta = order.eta_object.eta;
        order.custom_sort = sortCounter + order.eta_object.eta_value
      }
      else{
        order.custom_sort = sortCounter + order.customer_status_updated_at['seconds']
      }
    }
    else if (order.customer_status == CustomerStatus.NA){
      const sortCounter = 33333333333;
      order.custom_sort = sortCounter + order.pickup_at['seconds'];
    }
    return order
  }

  getSortedOrder(order: any) {
    const sortCounter = 99999;
    if (order.customer_status === CustomerStatus.ON_MY_WAY) {
      if (order.eta_object && typeof order.eta_object.eta_value === 'number') {
        order.eta = order.eta_object.eta;
        order.custom_sort = order.eta_object.eta_value;
      } else {
        if (!order.custom_sort) {
          order.custom_sort = sortCounter - 2;
        }
      }
    }
    if (order.customer_status === CustomerStatus.CHECKED_IN) {
      order.custom_sort = 0
    }
    if (order.customer_status === CustomerStatus.NA) {
      if (!order.custom_sort) {
        order.custom_sort = sortCounter - 1;
      }
    }
    return order
  }


  getOpenOrdersByLicense(merchantId: string, employeeId: string, license: string): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('member_vehicle.plate_number', '==', license)
      .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY])
      .where('merchant_id', '==', merchantId) //TODO: Fetch merchant id based on logged in worker
      .where('assigned_employee', '==', employeeId)
      .orderBy("pickup_at", "asc"))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          if ((order.customer_id != null) && (typeof (order.customer_id) === 'string')) {
            this.memberService.memberById(order.customer_id).subscribe((res: Member) => {
              order.customer = res;
            })
          }
          //check if location id is not empty
          //TODO: We need one more check "proceed only if it is of reference type" i.e., object = reference
          // if ((order.location_id !== null) && (typeof (order.location_id) === 'string')) {
          //   this.employeeService.employeeByLocation(order.location_id).subscribe((res: Employee[]) => {
          //     order.employee = res;
          //   })
          // }
          order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)
          if (order.customer_status === CustomerStatus.ON_MY_WAY) {
            this.orderLocationService.orderById(order.id)
              .subscribe((orderRes: Order) => {
                if (orderRes && orderRes['eta']) {
                  order['eta'] = orderRes['eta'];
                }
              })
          }
          if (!order.pickup_protocol) {
            order.pickup_protocol = initializeProofOfDelivery();
          }
          if ((order.assigned_employee !== null) && (order.status !== 'arrived') && (typeof (order.assigned_employee) === 'string')) {
            this.employeeService.employeeById(order.assigned_employee).subscribe((res: Employee) => {
              order.assigned_employee_object = res;
            })
          }
          if (order.customer_status === CustomerStatus.CHECKED_IN && order.status !== OrderStatus.COMPLETED) {
            if (this.subscription.has(order.id)) {
              this.subscription.get(order.id).unsubscribe()
            }
            this.subscription.set(order.id,
              this.everyMinute$.subscribe(() => {
                order.waiting_time = this.getTimeDifferenceString(order.customer_status_updated_at, true);
              }))
            // this.getTimeDifferenceString(order.customer_status_updated_at, true).subscribe((time)=>{
            //     order.waiting_time = time
            // })
          } else {
            for (let [orderId, subs] of this.subscription) {
              if (this.subscription.has(order.id)) {
                if (order.customer_status !== CustomerStatus.CHECKED_IN && order.id === orderId) {
                  subs.unsubscribe()
                }
              }
            }
          }
          return order;
        });
      }));
    // });
  }

  getOrdersByCustomer(id: string, status: string[], orderBy: string, order: firebase.firestore.OrderByDirection): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('customer_id', '==', id)
      .where('status', 'in', status)
      .orderBy(orderBy, order)
    )
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          if ((order.customer_id != null) && (typeof (order.customer_id) === 'string')) {
            this.merchantService.merchantById(order.merchant_id).subscribe((res: Merchant) => {
              order.merchant = res;
            })
          }
          if ((order.customer_id != null) && (typeof (order.customer_id) === 'string')) {
            this.locationService.locationByID(order.location_id).subscribe((res: Location) => {
              order.location = res;
            })
          }
          order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)
          return order;
        });
      }));
  }

  getOrdersByCustomerLocation(id: string, location_id: string, status: string[], orderBy: string, order: firebase.firestore.OrderByDirection): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('customer_id', '==', id)
      .where('location_id', '==', location_id)
      .where('status', 'in', status)
      .orderBy(orderBy, order)
    )
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          if ((order.customer_id != null) && (typeof (order.customer_id) === 'string')) {
            this.merchantService.merchantById(order.merchant_id).subscribe((res: Merchant) => {
              order.merchant = res;
            })
          }
          return order;
        });
      }));
  }

  getOrdersCompletedToday(merchantId: string, employeeId: string, startOfToday?: any, endOfToday?: any): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('assigned_employee', '==', employeeId)
      .where('merchant_id', '==', merchantId) //TODO: Fetch merchant id based on logged in worker
      .where('status', '==', OrderStatus.COMPLETED) //not complete orders
      .where('updated_at', '>=', startOfToday)
      .where('updated_at', '<=', endOfToday)
      //.orderBy("pickup_at", "asc")
    )
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          return order;
        });
      }));
  }

  getOnMyWayOrders(customerId: string): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('customer_id', '==', customerId)
      .where('customer_status', '==', CustomerStatus.ON_MY_WAY)
      .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY]))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          if (order.location_id != null) {
            this.locationService.locationById(order.location_id).subscribe((location: Location) => {
              order.location = location;
            })
          }
          return order;
        })
      }))
  }
  orderRead(status?: string): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName
      , ref => ref.where('status', '==', status))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          let locationRef = order.location_id as any;
          // let memberRef = order.customer_id as any;
          if ((order.customer_id != null) && (typeof (order.customer_id) === 'string')) {
            this.memberService.memberById(order.customer_id).subscribe((res: Member) => {
              order.customer = res;
            })
          }
          //check if location id is not empty
          //TODO: We need one more check "proceed only if it is of reference type" i.e., object = reference
          // if ((order.location_id !== null) && (typeof (order.location_id) === 'string')) {
          //   this.employeeService.employeeByLocation(order.location_id, this.merchantService.merchant.id).subscribe((res: Employee[]) => {
          //     order.employee = res;
          //   })
          // }
          if ((order.assigned_employee !== null) && (order.status !== 'arrived') && (typeof (order.assigned_employee) === 'string')) {
            this.employeeService.employeeById(order.assigned_employee).subscribe((res: Employee) => {
              order.assigned_employee_object = res;
            })
          }

          return order;

        });
      }));
  }

  orderById(id: string): __Observable<Order> {
    return this.firestore.collection<Order>(this.collectionName).doc(id)
      .valueChanges().pipe(map((order: Order) => {
        if (order) {
          order.id = id;
          order['pickup_day'] = this.getPickupDay(order.pickup_at['seconds'] * 1000)
        }
        return order;
      }));
  }
  getChatsByOrder(filterValue: any, filterKey: String): __Observable<Order[]> {
    const order$ = this.firestore.collection<Order>(this.collectionName, ref => ref
      .where(filterValue, '==', filterKey)
      .where("merchant_id", "==", this.merchantService.merchant.id)
      .where("location_id", "==", this.employeeService.defaultLocation)
      .orderBy("pickup_at", "asc"))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          // if ((order != null)) {
          //   this.recentchatsService.checkChatExistsForOrder(order.id).subscribe((chatRes: RecentChat[]) => {
          //     if (Object.keys(chatRes).length) {
          //       order.chat = chatRes[0];
          //     }
          //   })
          // }
          return order;

        });
      }));

    const recentChat$ = order$.pipe(mergeMap(orders => {
      return combineLatest(
        orders.map(order => {
          try {
            return this.recentchatsService.checkChatExistsForOrder(order.id);
          } catch (error) {
            return of({} as any);
          }
        })
      );
    }));

    const combinedData = combineLatest(
      order$,
      recentChat$.pipe(startWith(null)),
    );

    this.orderChat$ = combinedData.pipe(
      map(([orders, recentChats]) => {

        return orders.map((order) => {
          try {
            const chat = recentChats ? recentChats.find(recentChat => recentChat.find(chat => chat.order_id && chat.order_id === order.id)) : null;
            order.chat = (chat !== null && chat !== undefined) ? chat[0] : null;
            return order;
          } catch (error) {
            console.log(error)
          }
        })
      })
    );
    return this.orderChat$;
  }

  orderCreate(orderPayload: Order): Promise<any> {

    const order_status_updated_at = orderPayload.order_status_updated_at ? firebase.firestore.Timestamp.now() : null
    const customer_status_updated_at = orderPayload.customer_status_updated_at ? firebase.firestore.Timestamp.now() : null
    const member_vehicle = orderPayload.member_vehicle ? orderPayload.member_vehicle : {}

    var order: Order = {
      // customer_id: this.firestore.doc('/members/' + orderPayload.customer_id).ref,
      // location_id: this.firestore.doc('/locations/' + orderPayload.location_id).ref,
      external_order_id: orderPayload.external_order_id.toLowerCase(),
      customer_id: orderPayload.customer_id,
      location_id: orderPayload.location_id,
      order_date: orderPayload.order_date,
      created_at: firebase.firestore.Timestamp.now(),
      updated_at: firebase.firestore.Timestamp.now(),
      pickup_at: orderPayload.pickup_at,
      no_of_items: orderPayload.no_of_items,
      no_of_bags: orderPayload.no_of_bags,
      // proof_of_delivery: orderPayload.proof_of_delivery,
      // assigned_employee: this.firestore.doc('/employees/' + orderPayload.assigned_employee).ref,
      assigned_employee: orderPayload.assigned_employee,
      status: orderPayload.status,
      sub_status: orderPayload.sub_status,
      customer_status: orderPayload.customer_status,
      merchant_id: orderPayload.merchant_id,
      instructions: orderPayload.instructions,
      member_vehicle: member_vehicle,
      order_status_updated_at: order_status_updated_at,
      customer_status_updated_at: customer_status_updated_at,
      pickup_protocol: orderPayload.pickup_protocol,
      amount: orderPayload.amount,
      currency: orderPayload.currency,
      // collect_tax: orderPayload.collect_tax,
      item_details: orderPayload.item_details,
      order_files: orderPayload.order_files,
      order_channel: "merchant"
    }

    if (orderPayload.amount && orderPayload.amount > 0) {
      order.paid = false
    }

    return new Promise((resolve, reject) => {
      this.firestore.collection<Order>(this.collectionName).add(order).then(res => {
        resolve(res);
        // this.presentToast("Info updated");
      }, err => {
        reject(err)
      })
    });

  }
  // //Non_destructive update
  // orderPartialUpdate(id: string, orderPayload: Order): Promise<any> {
  //   const customer_status_updated_at = orderPayload.customer_status_updated_at ? orderPayload.customer_status_updated_at : null
  //   var order: Order = {
  //     customer_id: orderPayload.customer_id,
  //     location_id: orderPayload.location_id,
  //     updated_at: firebase.firestore.Timestamp.now(),
  //     pickup_at: orderPayload.pickup_at,
  //     no_of_items: orderPayload.no_of_items,
  //     no_of_bags: orderPayload.no_of_bags,
  //     assigned_employee: orderPayload.assigned_employee,
  //     status: orderPayload.status,
  //     sub_status: orderPayload.sub_status,
  //     customer_status: orderPayload.customer_status, //on my way/checked-in
  //     member_vehicle: Object.assign({}, orderPayload.member_vehicle),
  //     customer_status_updated_at: customer_status_updated_at,
  //     pickup_protocol: orderPayload.pickup_protocol
  //   }
  //   return new Promise((resolve, reject) => {
  //     this.firestore.collection<Order>(this.collectionName).doc(id).update(order).then(res => {
  //       resolve(res);
  //     }, err => {
  //       reject(err);
  //     })
  //   });
  // }

  //Non_destructive update
  orderPartialUpdate(id: string, orderPayload: Order): Promise<any> {
    const order_status_updated_at = orderPayload.order_status_updated_at ? orderPayload.order_status_updated_at : null
    const customer_status_updated_at = orderPayload.customer_status_updated_at ? orderPayload.customer_status_updated_at : null
    const instructions = orderPayload.instructions ? orderPayload.instructions : null
    const member_vehicle = orderPayload.member_vehicle ? orderPayload.member_vehicle : {}
    // delete order.id;
    var order: Order = {
      // customer_id: this.firestore.doc('/members/' + orderPayload.customer_id),
      // location_id: this.firestore.doc('/locations/' + orderPayload.location_id),
      external_order_id: orderPayload.external_order_id.toLowerCase(),
      customer_id: orderPayload.customer_id,
      location_id: orderPayload.location_id,
      updated_at: firebase.firestore.Timestamp.now(),
      order_date: orderPayload.order_date,
      pickup_at: orderPayload.pickup_at,
      no_of_items: orderPayload.no_of_items ? orderPayload.no_of_items : null,
      no_of_bags: orderPayload.no_of_bags ? orderPayload.no_of_bags : null,
      pickup_protocol: orderPayload.pickup_protocol,
      // assigned_employee: this.firestore.doc('/employees/' + orderPayload.assigned_employee),
      assigned_employee: orderPayload.assigned_employee ? orderPayload.assigned_employee : null,
      status: orderPayload.status,
      sub_status: orderPayload.sub_status,
      customer_status: orderPayload.customer_status,
      instructions: instructions,
      member_vehicle: member_vehicle,
      order_status_updated_at: order_status_updated_at,
      customer_status_updated_at: customer_status_updated_at,
      amount: orderPayload.amount ? orderPayload.amount : null,
      item_details: orderPayload.item_details ? orderPayload.item_details : null,
      currency: orderPayload.currency ? orderPayload.currency : null,
      // collect_tax: orderPayload.collect_tax ? orderPayload.collect_tax : false,
      order_files: orderPayload.order_files ? orderPayload.order_files : [],
    }

    if (orderPayload.paid && orderPayload.transaction_id){
      order.paid = orderPayload.paid
      order.transaction_id = orderPayload.transaction_id
    }
    return new Promise((resolve, reject) => {
      this.firestore.collection<Order>(this.collectionName).doc(id).update(order).then(res => {
        resolve(res);
        // this.presentToast("Info updated");
      }, err => {
        console.log(err)
        reject(err);
      })
    });
  }



  orderDelete(order: Order): Promise<any> {
    return new Promise((resolve, reject) => {
      this.firestore.collection<Order>(this.collectionName).doc(order.id).delete().then(res => {
        resolve(res);
      }, err => {
        reject(err);
      })

    });
  }

  createUpdateGeoLocation(cords: Array<number>, customerID: string, orderLocation: any, orderID: string, eta: string, eta_value: Number) {

    this.geoFirestore.doc(orderID).set(
      {
        coordinates: new firebase.firestore.GeoPoint(cords[0], cords[1]),
        last_updated_at: firebase.firestore.FieldValue.serverTimestamp(),
        created_at: firebase.firestore.FieldValue.serverTimestamp(),
        created_by: customerID,
        order_location: new firebase.firestore.GeoPoint(orderLocation[0], orderLocation[1]),
        order_id: orderID,
        eta: eta,
        eta_value: eta_value
      },
      { merge: true }
    ).then(_ => {
      console.log('added')
    })
      .catch(err => {
        console.log(err)
      })
  }

  getGeoLocationByOrder(orderId: string): __Observable<any> {
    console.log(orderId)
    return this.firestore.collection<any>('order_location').doc(orderId)
      .valueChanges();
  }

  //For deleting vehicle if open order does not associated with particular vehicle
  getOpenOrdersByLicenseMember(member_id: string, license: string): __Observable<Order[]> {
    return this.firestore.collection<Order>(this.collectionName, ref => ref
      .where('customer_id', '==', member_id)
      .where('member_vehicle.plate_number', '==', license)
      .where('status', 'in', [OrderStatus.ACTIVE, OrderStatus.READY])
      .orderBy("created_at", "asc"))
      .snapshotChanges()
      .pipe(map(actions => {
        return actions.map(a => {
          const order = a.payload.doc.data() as Order;
          order.id = a.payload.doc.id;
          return order;
        });
      }));
    // });
  }
  getCurrentLocation(timeOut, order, spinner?) {
    if (spinner) {
      this.presentLoading()
    }
    const timeout_var = setTimeout(() => {
      navigator.geolocation.getCurrentPosition((resp) => {
        if (resp) {
          order.currentLocation = resp;
          this.CurrentLocationInRadius(resp.coords.latitude, resp.coords.longitude, order);
          // if (order.customer_status === CustomerStatus.ON_MY_WAY) {
          this.fetchCurrentLocation(order, spinner);
          // }
        }
        else {
          if (spinner) {
            this.loadingController.dismiss()
            spinner = false
          }
          console.log('no response from getcurrentposition')
        }
      }, (error) => {
        if (spinner) {
          this.loadingController.dismiss()
          spinner = false
          this.presentToast('Error in fetching location. Please ensure location is on and try again.')
        }
        console.log('Error getting location', error);
      },
        { timeout: 15000 }) // timeout on failure after 15sec
    }, timeOut);
    this.locationTimers[order.id] = timeout_var
  }

  myStopFunction(order_id) {
    clearTimeout(this.locationTimers[order_id]);
  }

  fetchCurrentLocation(order: any, spinner?) {
    var timeout
    if (order.status === OrderStatus.COMPLETED || order.customer_status === CustomerStatus.CHECKED_IN) {
      return;
    } else {
      //fetching Eta  of Location using Cloud Function
      const origin_lat = order.currentLocation.coords.latitude
      const origin_lng = order.currentLocation.coords.longitude
      const dest_lat = order.coords.latitude
      const dest_lng = order.coords.longitude

      const body = {
        origin: origin_lat + ',' + origin_lng,
        destination: dest_lat + ',' + dest_lng
      }

      const functionsPayload = firebase.functions().httpsCallable('fetchEta');
      functionsPayload({
        origin: body.origin,
        destination: body.destination
      }).then((result) => {
        if (result && result.data.eta) {
          const eta = result.data.eta;
          const etaInMints = Math.round(eta.value / 60)
          timeout = this.getTimeOut(etaInMints)
          const locSub = this.getGeoLocationByOrder(order.id)
            .pipe(take(1))
            .subscribe(res => {
              let updateOrderLocation: boolean = true
              if (res && res.eta) {
                console.log('member_location/order_location updated')
                const lastEta = res.eta_value ? Math.round(res.eta_value / 60) : this.getEtaInMinutes(res.eta)
                const difference = Math.abs(lastEta - etaInMints);
                updateOrderLocation = difference === 0 ? false : true
              }

              if (updateOrderLocation) {
                this.memberService.setGeoLocation([origin_lat, origin_lng], order.customer_id,
                  [dest_lat, dest_lng], order.id, this.getText(eta.value), eta.value)
                this.createUpdateGeoLocation([origin_lat, origin_lng], order.customer_id,
                  [dest_lat, dest_lng], order.id, this.getText(eta.value), eta.value)
              }
              else {
                console.log('Same Eta')
              }

              if (order.customer_status === CustomerStatus.NA || order.customer_status === 'cancel_checked_in') {
                order.customer_status_updated_at = new Date;
                order.customer_status = CustomerStatus.ON_MY_WAY;
              // Cancel Employee acknowledge and onmyway
            if(order.customer_status ==='cancel_checked_in'){
              order.pickup_protocol.check_in_acknowledged = { status: false, updated_at: firebase.firestore.Timestamp.now() }
              order.pickup_protocol.employee_on_my_way = { status: false, updated_at: firebase.firestore.Timestamp.now() }
          }
                order.pickup_protocol.on_my_way = { status: true, updated_at: new Date }
                this.orderPartialUpdate(order.id, order);
                // this.presentToast('Info Updated');
              }

              if (spinner) {
                this.loadingController.dismiss()
                spinner = false
              }
              locSub.unsubscribe();
            });
          this.getCurrentLocation(timeout, order);
        }
        else {
          if (spinner) {
            this.loadingController.dismiss()
            spinner = false
          }
          console.log('google api resulted in no eta 1')
        }

      })
        .catch((error: any) => {
          if (spinner) {
            this.loadingController.dismiss()
            spinner = false
          }
          // Getting the Error details.
          console.log(error);
          this.getCurrentLocation(30000, order);
        });
    }

  }
  getText(seconds) {
    if (seconds < 60) {
      return '1min'
    }
    const d = Math.floor(seconds / (3600 * 24));
    seconds -= d * 3600 * 24;
    const h = Math.floor(seconds / (3600));
    seconds -= h * 3600;
    const m = Math.floor(seconds / (60));
    seconds -= m * 60;

    const tmp = [];
    (d) && tmp.push(d + 'days');
    (d || h) && tmp.push(h + 'hours');
    (d || h || m) && tmp.push(m + 'mins');
    //tmp.push(seconds+ 'seconds');

    return tmp.join(' ');



  }

  getTimeOut(etaInMints) {
    if (etaInMints > 120) { //eta greater than 2hrs
      return 10 * 60 * 1000; // 10 mins
    }
    else if (etaInMints >= 60 && etaInMints <= 120) { //eta greater than 30mints & less than 2 hrs
      return 5 * 60 * 1000; // 5mins
    }
    else if (etaInMints >= 30 && etaInMints < 60) { //eta greater than 30mints & less than 1hr
      return 2 * 60 * 1000; // 2mints
    }
    else if (etaInMints > 15 && etaInMints < 30) { //eta greater than 15mints & less than 30mints
      return 60 * 1000 // 1mint
    }
    else { // eta less and equal than 15mints
      return 30 * 1000; // 30 seconds
    }
  }

  getEtaInMinutes(eta) {
    var day
    var hr;
    var mint;
    const etaArray = eta.match(/\d+/g).map(Number) as Array<any>;
    if (eta.includes('day')) {
      day = etaArray[0]
      hr = etaArray[1]
      return day * 24 * 60 + hr * 60
    }
    else if (eta.includes('hours')) {
      hr = etaArray[0]
      mint = etaArray[1]
      return hr * 60 + mint
    }
    else {
      mint = etaArray[0]
      return mint
    }
  }

  async presentToast(err: string) {
    const toast = await this.toastController.create({
      message: err,
      duration: 2000
    });
    toast.present();
  }


  CurrentLocationInRadius(lat, lng, order) {
    var radius = 3.21869   //2miles
    this.geolocationService.getGeoLocation(radius, [lat, lng])
      .then(res => {
        res.forEach(element => {
          if (element.id == order.location_id) {
            this.ordersIn2miles[order.id] = true
            this.setMiles();
            return
          }
        })
      })
  }

  incrementMeteredBilling(subs_item_metered_id) {
    const data = {
      "subs_item_metered_id": subs_item_metered_id,
      "quantity": 1
    }
    var cloudFunctionCall = firebase.functions().httpsCallable('incrementMeteredBilling');
    return cloudFunctionCall(data)
      .then(res => {
        console.log(res)
        // this.DestroySpinner()
        return res.data
      })
      .catch(err => {
        // this.DestroySpinner()
        console.log(err)
        return err;
      })
  }

  //Provides the capability to get order status based on sub-status
  getOrderStatus(sub_status: OrderSubStatus): OrderStatus {
    var result: OrderStatus
    switch (sub_status) {
      case OrderSubStatus.RECEIVED:
      case OrderSubStatus.PREPARING:
        result = OrderStatus.ACTIVE
        break;
      case OrderSubStatus.READY_FOR_PICKUP:
      case OrderSubStatus.PICKUP_IN_PROGESS:
        result = OrderStatus.READY
        break;
      case OrderSubStatus.COMPLETE:
      case OrderSubStatus.CANCEL:
        result = OrderStatus.COMPLETED
        break;
    }
    return result
  }

  getTimeDifferenceString(orderPickupTimeStamp: any, showAbsoluteDifference: boolean): String {
    var result = "Not Available"

    let now = new Date()
    let orderPickupTime = new Date(Number(orderPickupTimeStamp['seconds'] * 1000));
    // let orderPickupTime = new Date(orderPickupTimeStamp);
    //calculate the time difference
    let elapsedTime = (orderPickupTime.getTime() - now.getTime());

    let minutesDifference = Math.abs(Math.floor(elapsedTime / 1000 / 60));
    const minDiffrence = Math.floor(elapsedTime / 1000 / 60);
    if (minutesDifference || minutesDifference === 0) {

      if (minutesDifference > 1) {
        result = minutesDifference + " Mins"
      }
      else {
        result = minutesDifference + " Min"
      }

    }
    //convert to hours if required
    if (minutesDifference > 60) {
      const hours = Math.floor(minutesDifference / 60)
      if (hours > 1) {
        result = hours + " Hours"
      }
      else {
        result = hours + " Hour"
      }
    }

    if (minutesDifference > 1440) {
      var days = Math.floor(minutesDifference / 60 / 24)
      if (days > 1) {
        result = days + " Days"
      }
      else {
        result = days + " Day"
      }
    }

    if (showAbsoluteDifference === false) {
      if (minDiffrence <= 0) {
        result = 'NOW'
      }
    }

    // when pickup time is passed current time
    // if (minutesDifference <= 0) {
    //   result = 'NOW'
    // }

    //convert to days if required

    return result
  }
  getPickupDay(date: any): string {
    try {
      const pickupTime = new Date(date);
      const today = new Date();
      if (pickupTime.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0)) {
        return 'Today at ' + this.datePipe.transform(new Date(date), 'h:mm a');
      } else if (pickupTime.setHours(0, 0, 0, 0) === today.setHours(24, 0, 0, 0)) {
        return 'Tomorrow at ' + this.datePipe.transform(new Date(date), 'h:mm a');
      } else {
        return this.datePipe.transform(new Date(date), 'MMMM d, h:mm a');
      }
    } catch (error) {
      return ''
    }

  }

  orderSetID(order: Order): Promise<any> {
    const id = order.id
    order.created_at = firebase.firestore.Timestamp.now()
    order.updated_at = firebase.firestore.Timestamp.now() 
    delete order.id;
    return new Promise((resolve, reject) => {
      this.firestore.collection<Employee>(this.collectionName).doc(id).set(order).then(res => {
        resolve(res);
      }, err => {
        reject(err)
      })
    });
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: 'Please wait...',
    });
    await loading.present();
  }

  createLineItems(cart ,tipDetails, promotionDetails): LineItems[] {
    cart.line_items.forEach(element => {
      if(element.type == "tip"){
        element.tipDetail = tipDetails
      }
      else if (element.type == "promotion"){
        element.promotionDetail = promotionDetails
      }
    });
    return cart.line_items
  }

}